@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<h1>
  @switch(editing) {
    @case(true) {
      <span>Edit VTN {{id}}</span>
    }
    @case(false) {
      <span>Register a new VTN</span>
    }
  }
</h1>
<form [formGroup]="vtnForm" class="form-horizontal">
  <div class="form-group">
    <label for="vtnId"> VTN id: </label>
    <input id="vtnId" class="form-control" name="id" type="text" formControlName="vtn_id" required>
    @if(vtnForm.get('vtn_id')?.invalid && (vtnForm.get('vtn_id')?.dirty || vtnForm.get('vtn_id')?.touched)) {
      <div class="text-danger">
        <div *ngIf="vtnForm.get('vtn_id')?.errors?.['required']">VTN ID is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="uri"> URI </label>
    <input id="uri" class="form-control" type="text" formControlName="uri" required>
    @if(vtnForm.get('uri')?.invalid && (vtnForm.get('uri')?.dirty || vtnForm.get('uri')?.touched)) {
      <div class="text-danger">
        <div *ngIf="vtnForm.get('uri')?.errors?.['required']">URI is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="mode"> Mode </label>
    <select id="mode" class="form-control" formControlName="mode" required>
      @for(option of modeOptions; track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
      }
    </select>
    @if(vtnForm.get('mode')?.invalid && (vtnForm.get('mode')?.dirty || vtnForm.get('mode')?.touched)) {
      <div class="text-danger">
        <div *ngIf="vtnForm.get('mode')?.errors?.['required']">Mode is required.</div>
      </div>
    }
  </div>

  <!-- Single VEN Mode (only for PUSH mode) -->
  <div class="form-group" *ngIf="isPushMode">
    <label for="single_ven_mode">Single VEN Mode</label>
    <div class="checkbox">
      <label>
        <input
          type="checkbox"
          id="single_ven_mode"
          formControlName="single_ven_mode"
          [disabled]="isSingleVenModeDisabled"
        />
        Enable single VEN mode (allows only one VEN to be associated with this VTN)
      </label>
    </div>
    <small class="form-text text-muted">
      Available only in Push mode. When enabled, this VTN can only have one VEN associated.
    </small>
  </div>

  <!-- Poll-specific fields -->
  @if(isPollMode) {
    <div class="form-group">
      <label for="ca"> CA cert (optional)</label>
      <input id="ca" class="form-control" type="file" #filePicker (change)="onCertificatePicked($event, 'ca')">
      @if(vtnDto.ca) {
        <div class="mt-2">
          <strong>CA Fingerprint:</strong> {{ caFingerprint }}
        </div>
      }
    </div>

    <div class="form-group">
      <label for="poll_failure_limit"> Poll Failure Limit (optional)</label>
      <br>
      <small>Number of consecutive polling failures allowed before marking VTN as unhealthy.
        If unset or 0, will never be marked as unhealthy. </small>
      <input id="poll_failure_limit" class="form-control" type="number" formControlName="poll_failure_limit">
    </div>
  }

  <!-- Push-specific fields -->
  @if(isPushMode) {
    <div class="form-group">
      <label for="vtn_public_cert">VTN Public Certificate @if(!editing || !vtnCertFingerprint) {<span>(required for push mode)</span>}</label>
      <input
        id="vtn_public_cert"
        class="form-control"
        name="vtn_public_cert"
        type="file"
        (change)="onCertificatePicked($event, 'vtn')">
      <small class="form-text text-muted">
        @if(editing && vtnCertFingerprint) {
          <span>A certificate is already uploaded. Upload a new one only if you want to replace it.</span>
        } @else {
          <span>Upload the VTN's public certificate. Fingerprint will be calculated automatically for authentication.</span>
        }
      </small>

      <!-- Display existing or calculated fingerprint -->
      @if(vtnCertFingerprint) {
        <div class="mt-2">
          <strong>@if(editing) {<span>Current Fingerprint:</span>} @else {<span>Calculated Fingerprint:</span>}</strong>
          <code>{{ vtnCertFingerprint }}</code>
        </div>
      }

      @if(vtnForm.get('fingerprint')?.invalid && (vtnForm.get('fingerprint')?.dirty || vtnForm.get('fingerprint')?.touched)) {
        <div class="text-danger">
          <div *ngIf="vtnForm.get('fingerprint')?.errors?.['required']">VTN certificate is required for push mode.</div>
        </div>
      }
    </div>
  }

  <div class="form-group mt-4">
    <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="vtnForm.invalid">Save</button>
    <a class="btn" (click)="backPage('/vtns', router)">Cancel</a>
  </div>
</form>
